import isObject from 'lodash/isObject';

import { MODULE_NAME } from './const';
import StoreModuleService from '../StoreModuleService';

const buildActionGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const getAllActions = buildActionGetterObject('getAllActions');
export const getAction = buildActionGetterObject('getAction');
export const getActionBySlug = buildActionGetterObject('getActionBySlug');
export const getActionNoun = buildActionGetterObject('getActionNoun');
export const getActionParams = buildActionGetterObject('getActionParams');
export const getIfActionHasDynamicParams = buildActionGetterObject('getIfActionHasDynamicParams');

const getters = {
	[getAllActions.getter]: (state) => state.data,
	[getAction.getter]: (state) => (actionId) => state.data[actionId],
	[getActionBySlug.getter]: (state) => (actionSlug) => Object.values(state.data).find((a) => a.key === actionSlug),
	[getActionParams.getter]: (state, getters) => (actionId) => {
		const action = getters[getAction.getter](actionId);
		return action ? action.params.filter((param) => isObject(param)) : [];
	},
	[getIfActionHasDynamicParams.getter]: (state, getters) => (actionId) =>
		!!getters[getAction.getter](actionId)?.params.some((param) => !isObject(param)),
	[getActionNoun.getter]: (state, getters) => (actionId) => getters[getAction.getter](actionId)?.noun,
};

export default getters;
